export const ROTA_DESPESAS = "/admin/financeiro/despesas";
export const ROTA_NOVA_DESPESA = "/admin/financeiro/despesas/nova";
export const rotaEditarDespesa = (id) => `/admin/financeiro/despesas/${encodeURIComponent(id)}/editar`;
